class ModelPlaceholders {
  static _getFieldPlaceholderScaffold(label, component, description = 'description', placeholder = 'placeholder') {
    return { label, description, placeholder, component };
  }

  static _getFieldScaffold(item) {
    return { ...item };
  }

  static _getFieldPlaceholderScaffoldWithOptions(
    label,
    component,
    description = 'description',
    options = [
      { value: 'value one', score: '' },
      { value: 'value two', score: '' }
    ]
  ) {
    return { label, description, options, component };
  }

  static getFieldPlaceholder(type, sectionLabel) {
    switch (type) {
      case 'sectionDivider':
        return this._getFieldPlaceholderScaffold(sectionLabel ? sectionLabel : 'Section Divider', type);
      case 'pageBreak':
        return this._getFieldPlaceholderScaffold('Page Break', type, null, null);
      case 'freeText':
        return this._getFieldPlaceholderScaffold('Form Description', type, null, null);
      case 'fileEmbedded':
        return this._getFieldPlaceholderScaffold('File Embedded', type, null, null);
      case 'userName':
        return this._getFieldPlaceholderScaffold('User Name:', type, 'VALUE WILL GO HERE', null);
      case 'propertyName':
        return this._getFieldPlaceholderScaffold('Property Name:', type, 'VALUE WILL GO HERE', null);
      case 'pmsPropertyId':
        return this._getFieldPlaceholderScaffold('PMS Property Id:', type, 'VALUE WILL GO HERE', null);
      case 'propertyAddress':
        return this._getFieldPlaceholderScaffold('Property Complete Address:', type, 'VALUE WILL GO HERE', null);
      case 'propertyInfo':
        return this._getFieldPlaceholderScaffold('Property Field:', type, 'VALUE WILL GO HERE', null);
      case 'unitNumber':
        return this._getFieldPlaceholderScaffold('Unit Number:', type, 'VALUE WILL GO HERE', null);
      case 'unitBuilding':
        return this._getFieldPlaceholderScaffold('Unit Building:', type, 'VALUE WILL GO HERE', null);
      case 'unitInfo':
        return this._getFieldPlaceholderScaffold('Unit Field:', type, 'VALUE WILL GO HERE', null);
      case 'tenantId':
        return this._getFieldPlaceholderScaffold('Tenant ID:', type, 'VALUE WILL GO HERE', null);
      case 'textInput':
        return this._getFieldPlaceholderScaffold('Text input', type);
      case 'phoneInput':
        return this._getFieldPlaceholderScaffold('Phone input', type);
      case 'textArea':
        return this._getFieldPlaceholderScaffold('Text area', type);
      case 'checkbox':
        return this._getFieldPlaceholderScaffoldWithOptions('Checkbox', type, 'description');
      case 'radio':
        return this._getFieldPlaceholderScaffoldWithOptions('Radio', type, 'description');
      case 'select':
        return this._getFieldPlaceholderScaffoldWithOptions('Select', type, 'description');
      case 'numberInput':
        return this._getFieldPlaceholderScaffold('Number Input', type);
      case 'currencyInput':
        return this._getFieldPlaceholderScaffold('Currency Input', type);
      case 'starRate':
        return this._getFieldScaffold({
          label: 'Star Rating',
          component: type,
          description: 'description',
          numberStars: 10
        });
      case 'sliderRange':
        return this._getFieldScaffold({
          label: 'Slider Range',
          component: type,
          description: 'description',
          minValue: 0,
          maxValue: 100,
          step: 25
        });
      case 'dateInput':
        return this._getFieldPlaceholderScaffold('Date Input', type, 'description', null);
      case 'dateTimeInput':
        return this._getFieldPlaceholderScaffold('Date Time Input', type, 'description', null);
      case 'timeInput':
        return this._getFieldPlaceholderScaffold('Time Input', type, 'description', null);
      case 'fileImageInput':
        return this._getFieldPlaceholderScaffold('File/Photo Input', type, 'description', null);
      case 'fileInput':
        return this._getFieldPlaceholderScaffold('File Input', type, 'description', null);
      case 'imageInput':
        return this._getFieldPlaceholderScaffold('Photo Input', type, 'description', null);
      case 'imageMultipleInput':
        return this._getFieldPlaceholderScaffold('Multiple Photo Input', type, 'description', null);
      case 'signatureInput':
        return this._getFieldPlaceholderScaffold('Signature Input', type, 'description', null);
      case 'ratingScale3pt':
        return this._getFieldScaffold({
          label: '3-pt Rating Scale',
          component: type,
          description: 'description',
          options: [
            { value: 'Bad', score: '' },
            { value: 'OK', score: '' },
            { value: 'Great', score: '' }
          ],
          defaultValue: 'OK'
        });
      default:
        return this._getFieldPlaceholderScaffold('Text Input', type);
    }
  }
}

export default ModelPlaceholders;
